export default __webpack_public_path__ + "static/media/cover-sign_in.5f9e2448.jpeg";